import { marked } from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/github-dark.css';
import DOMPurify from 'dompurify';
// Import specific languages we need
import python from 'highlight.js/lib/languages/python';
import javascript from 'highlight.js/lib/languages/javascript';
import bash from 'highlight.js/lib/languages/bash';
import json from 'highlight.js/lib/languages/json';

// Register the languages
hljs.registerLanguage('python', python);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('json', json);

// Configure marked with syntax highlighting
marked.setOptions({
    renderer: new marked.Renderer(),
    highlight: (code, language) => {
        try {
            // Default to python for code blocks without language or unsupported languages
            const lang = language ? language.toLowerCase() : 'python';

            // Handle Wardley maps as Python code blocks
            if (lang === 'wardley') {
                return hljs.highlight(code, {
                    language: 'python',
                    ignoreIllegals: true
                }).value;
            }

            // Verify language is supported
            if (hljs.getLanguage(lang)) {
                return hljs.highlight(code, {
                    language: lang,
                    ignoreIllegals: true
                }).value;
            }
            // For unsupported languages, use python instead of auto-detect
            return hljs.highlight(code, {
                language: 'python',
                ignoreIllegals: true
            }).value;
        } catch (err) {
            console.error('Highlight error:', err);
            return code;
        }
    },
    gfm: true,
    breaks: true,
    pedantic: false,
    smartLists: true,
    langPrefix: 'language-'
});

export function renderMarkdown(markdown) {
    const html = marked.parse(markdown);
    return html;
}